import { CCard } from '@coreui/react';
import React, { useState } from 'react';
import { ManagerTable } from '../../../components/pages/utils';

export default function Analytics({ managers, status, error }) {
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));

  const handleDepartmentChange = (e) => {
    setSelectedDepartment(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(parseInt(e.target.value));
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const getYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 5 }, (_, i) => currentYear - i);
  };

  const getMonthsOfSelectedYear = () => {
    return Array.from({ length: 12 }, (_, i) => {
      const month = selectedYear === 2024 ? (i + 1).toString() : (i + 1).toString().padStart(2, '0');
      return { value: `${selectedYear}-${month}`, label: new Date(selectedYear, i).toLocaleString('ru-RU', { month: 'long' }) };
    });
  };

  const selectedMonthValue = selectedMonth.split('-')[1];
  const formattedMonth = selectedYear === 2024 ? parseInt(selectedMonthValue).toString() : selectedMonthValue.padStart(2, '0');
  const targetDate = `${selectedYear}-${formattedMonth}`;

  const filteredData = managers.filter((manager) => manager.datas === targetDate);
  const filteredManagers = filteredData.flatMap((manager) =>
    manager.managers.filter((manager) =>
      selectedDepartment ? manager.otdel === selectedDepartment : true
    )
  );

  return (
    <CCard className='mb-10 p-4'>
      <div className='flex justify-between'>
        <div className='p-2 my-4 border flex gap-5'>
          <label>Выберите отдел</label>
          <select value={selectedDepartment} onChange={handleDepartmentChange}>
            <option value="">Не выбрано</option>
            <option value="Монако">Монако</option>
            <option value="Кайрат">Кайрат</option>
            <option value="Туран">Туран</option>
            <option value="Ильяс">Ильяс</option>
          </select>
        </div>
        <div className='p-2 my-4 border flex gap-5'>
          <label>Выберите год</label>
          <select value={selectedYear} onChange={handleYearChange}>
            {getYears().map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>
        <div className='p-2 my-4 border flex gap-5'>
          <label>Выберите месяц</label>
          <select value={selectedMonth} onChange={handleMonthChange}>
            <option value="">Не выбрано</option>
            {getMonthsOfSelectedYear().map((month) => (
              <option key={month.value} value={month.value}>{month.label}</option>
            ))}
          </select>
        </div>
      </div>
      <ManagerTable managers={filteredManagers} status={status} error={error} />
    </CCard>
  );
}